"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueStruct = exports.QueueStatsStruct = void 0;
const superstruct_1 = require("superstruct");
const Timestamp_1 = require("../utils/Timestamp");
exports.QueueStatsStruct = (0, superstruct_1.type)({
    averageProcessingTimeSec: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    averageProcessingTimeUpdatedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct), // last time the average processing time was updated
});
exports.QueueStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), 'New Queue'),
    isMaxLengthEnabled: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    maxLength: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    visitorsToNotify: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.number)()), 3),
    estimatedWaitingTimeMode: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.enums)(['auto', 'constant', 'off'])), 'auto'),
    estimatedWaitingTimeConstantMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    isOnlyInOpeningHours: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
    paused: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false), // if true, queue will be paused
});
exports.QueueStruct.type = 'Queue';
//# sourceMappingURL=queue.js.map